import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ConcurrencySlider',
  props: {
    modelValue: {},
    label: { default: 'Concurrency' },
    tooltip: { default: 'Maximum number of helper agents to run concurrently.' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

// The workflow Concurrency control (max helper agents running at once, 1–10), shared by the
// Advanced WorkflowEditor and the simple AutomationDetail so both surfaces edit the same
// WorkflowConfig.concurrency field with the same range and behavior. Label/tooltip are props
// because the simple lens uses plain-language copy; defaults are the Advanced editor's wording.


const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { text: _ctx.tooltip }, {
    activator: _withCtx(({ props: tooltipProps }) => [
      _createVNode(_component_v_slider, _mergeProps(tooltipProps, {
        label: _ctx.label,
        "model-value": _ctx.modelValue,
        min: 1,
        max: 10,
        step: "1",
        "thumb-label": "",
        color: "secondary",
        "thumb-color": "primary",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => emit('update:modelValue', v))
      }), null, 16, ["label", "model-value"])
    ]),
    _: 1
  }, 8, ["text"]))
}
}

})